import { RepositoryFactory } from "@/repositories/RepositoryFactory";

const ContactFormRepository = RepositoryFactory.get("contactForm");

const actions = {
  sendMail(context, payload) {
    return ContactFormRepository.sendMail(payload);
  },
};

export default {
  namespaced: true,
  actions,
};
